export const Size = {
    tiny: 'tiny',
    small: 'small',
    regular: 'regular',
    large: 'large',
    xl: 'xl',
    none: 'none',
};
export var ModalOrigin;
(function (ModalOrigin) {
    ModalOrigin["RETRY_BUTTON"] = "retryButton";
    ModalOrigin["PRO_PAGE"] = "proPage";
    ModalOrigin["SHARE_DROPDOWN"] = "shareDropdown";
    ModalOrigin["PRICING_TABLE"] = "pricingTable";
    ModalOrigin["TRY_COPILOT"] = "tryCopilot";
    ModalOrigin["TRY_RESEARCH"] = "tryResearch";
    ModalOrigin["TRY_LABS"] = "tryLabs";
    ModalOrigin["PRO_HOVER_CARD_BUTTON"] = "proHoverCardButton";
    ModalOrigin["PRO_REASONING_SELECTOR"] = "proReasoningSelector";
    ModalOrigin["LIBRARY_PAGE"] = "libraryPage";
    ModalOrigin["SPACES_PAGE"] = "spacesPage";
    ModalOrigin["SPACES_LANDING"] = "spacesLanding";
    ModalOrigin["SPACES_TEMPLATES"] = "spacesTemplates";
    ModalOrigin["DISCOVER_TOPICS"] = "discoverTopics";
    ModalOrigin["COLLECTIONS"] = "collections";
    ModalOrigin["SPACES"] = "spaces";
    ModalOrigin["THREAD_SOCIAL"] = "threadSocial";
    ModalOrigin["MOBILE_SIGNUP"] = "mobileSignup";
    ModalOrigin["RELATED_QUERIES"] = "relatedQueries";
    ModalOrigin["RELATED_QUERY_UPSELL"] = "relatedQueryUpsell";
    ModalOrigin["DEEP_RESEARCH_RELATED_QUERY_UPSELL"] = "deepResearchRelatedQueryUpsell";
    ModalOrigin["FILE_UPLOAD"] = "fileUpload";
    ModalOrigin["SPACES_FILE_UPLOAD"] = "spacesFileUpload";
    ModalOrigin["TRY_PRO"] = "tryPro";
    ModalOrigin["VIEWER_SEAT_REQUEST"] = "viewerSeatRequest";
    ModalOrigin["HOMEPAGE_FREE_PLAN_UPSELL"] = "homepageFreePlanUpsell";
    ModalOrigin["LOGIN_BUTTON"] = "loginButton";
    ModalOrigin["ADD_ACCOUNT"] = "addAccount";
    ModalOrigin["SIGNUP_BUTTON"] = "signupButton";
    ModalOrigin["LOGIN_BUTTON_HEADER"] = "loginButtonHeader";
    ModalOrigin["SIGNUP_BUTTON_HEADER"] = "signupButtonHeader";
    ModalOrigin["FLOATING_SIGNUP"] = "floatingSignup";
    ModalOrigin["SIDEBAR_LOGIN_AD"] = "sidebarLoginAd";
    ModalOrigin["SIDEBAR_PRO_UPSELL"] = "sidebarProUpsell";
    ModalOrigin["SIDEBAR_TEAM_INVITE"] = "sidebarTeamInvite";
    ModalOrigin["SIDE_TEXT_PRO_UPSELL"] = "sideTextProUpsell";
    ModalOrigin["VISITOR_GATE"] = "visitorGate";
    ModalOrigin["HARD_VISITOR_GATE"] = "hardVisitorGate";
    ModalOrigin["HARD_PAYWALL_GATE"] = "hardPaywallGate";
    ModalOrigin["LIMITED_FREE_TIER_RATE_LIMITED"] = "limitedFreeTierRateLimited";
    ModalOrigin["LIMITED_FREE_TIER_RATE_LIMITED_INPUT_BANNER"] = "limitedFreeTierRateLimitedInputBanner";
    ModalOrigin["FRAUD_BLOCKING_GATE"] = "fraudBlockingGate";
    ModalOrigin["FRAUD_AUTHWALL_GATE"] = "fraudAuthwallGate";
    ModalOrigin["SHARED_THREAD_LOGIN_GATE"] = "sharedThreadLoginGate";
    ModalOrigin["SHARED_THREAD_INSTALL_GATE"] = "sharedThreadInstallGate";
    ModalOrigin["REQUEST_ACCESS_LOGIN_GATE"] = "requestAccessLoginGate";
    ModalOrigin["PPLX_APP_ACCESS_LOGIN_GATE"] = "pplxAppAccessLoginGate";
    ModalOrigin["GENERATE_IMAGE"] = "generateImage";
    ModalOrigin["PPLX_API_PAGE"] = "pplxApiPage";
    ModalOrigin["FILES_PAGE"] = "filesPage";
    ModalOrigin["PURCHASES_PAGE"] = "purchasesPage";
    ModalOrigin["GOOGLE_ONETAP_HOME"] = "oneTapHome";
    ModalOrigin["GOOGLE_ONETAP_THREAD"] = "oneTapThread";
    ModalOrigin["GOOGLE_ONETAP_PAGE"] = "oneTapPage";
    ModalOrigin["GOOGLE_ONETAP_DISCOVER"] = "oneTapDiscover";
    ModalOrigin["GOOGLE_ONETAP_UNKNOWN"] = "oneTap";
    ModalOrigin["ONBOARDING"] = "onboarding";
    ModalOrigin["SUBSCRIPTION_PROMO_DESCRIPTION"] = "subscriptionPromoDescription";
    ModalOrigin["PRO_TRIAL_END_HOMEPAGE_UPSELL"] = "proTrialEndHomepageUpsell";
    ModalOrigin["NEXTAUTH_SIGNIN_PAGE"] = "nextauthSignInPage";
    ModalOrigin["DISCOUNT_CODE_BANNER"] = "discountCodeBanner";
    ModalOrigin["PARTNER_CODE"] = "partnerCode";
    ModalOrigin["ARTICLE_NEW"] = "articleNew";
    ModalOrigin["THREAD_TO_ARTICLE"] = "threadToArticle";
    ModalOrigin["ORG_CREATE"] = "orgCreate";
    ModalOrigin["ORG_PANEL"] = "orgPanel";
    ModalOrigin["LOSS_AVERSION_MODAL"] = "lossAversionModal";
    ModalOrigin["NEW_THREAD_BUTTON"] = "newThreadButton";
    ModalOrigin["NEW_THREAD_SHORTCUT"] = "newThreadShortcut";
    ModalOrigin["DISCOVER_BUTTON"] = "discoverButton";
    ModalOrigin["THREAD_BOOKMARK_BUTTON"] = "threadBookmarkButton";
    ModalOrigin["PAGE_BOOKMARK_BUTTON"] = "pageBookmarkButton";
    ModalOrigin["DISCOVER_FEED_BOOKMARK_BUTTON"] = "discoverFeedBookmarkButton";
    ModalOrigin["WELCOME_BACK"] = "welcomeBack";
    ModalOrigin["LEFT_HAND_NAV"] = "leftHandNav";
    ModalOrigin["SETTINGS"] = "settings";
    ModalOrigin["SEARCH_MODE_EXHAUSTED_POPOVER"] = "searchModeExhaustedPopover";
    ModalOrigin["PRO_FEATURE_LIMIT_BANNER"] = "proFeatureLimitBanner";
    ModalOrigin["BUY_FROM_MERCHANT_BUTTON"] = "buyFromMerchantButton";
    ModalOrigin["FINANCE_WATCHLIST"] = "financeWatchlist";
    ModalOrigin["DOWNLOAD_COMET"] = "downloadComet";
    ModalOrigin["GROW_COMET"] = "growComet";
    ModalOrigin["GROW_COMET_AFFILIATE"] = "growCometAffiliate";
    ModalOrigin["GROW_COMET_STUDENTS"] = "growCometStudents";
    ModalOrigin["GROW_COMET_STUDENTS_COUNTRY"] = "growCometStudentsCountry";
    ModalOrigin["PARTNER_COMET"] = "partnerComet";
    ModalOrigin["COMET_ONBOARDING"] = "cometOnboarding";
    ModalOrigin["WORKSPACE_ONBOARDING"] = "workspaceOnboarding";
    ModalOrigin["PROMO_REDEMPTION"] = "promoRedemption";
    ModalOrigin["CONNECTORS_PAGE"] = "connectorsPage";
    ModalOrigin["CONNECTORS_UPSELL"] = "connectorsUpsell";
    ModalOrigin["MARKETING_LANDING_PAGE"] = "marketingLandingPage";
    ModalOrigin["FINANCE_TRANSCRIPT"] = "financeTranscript";
    ModalOrigin["FINANCE_RESEARCH"] = "financeResearch";
    ModalOrigin["LJJ_LANDING_PAGE"] = "ljjLandingPage";
    ModalOrigin["VOICE_TO_VOICE_BUTTON"] = "voiceToVoiceButton";
    ModalOrigin["REFERRAL_PAGE"] = "referralPage";
    ModalOrigin["SOURCES_VIEW_MORE"] = "sourcesViewMore";
    ModalOrigin["NEWS_VIEW_MORE"] = "newsViewMore";
    ModalOrigin["SPORTS_WATCHLIST"] = "sportsWatchlist";
    ModalOrigin["IMAGE_GENERATION_IN_THREAD"] = "imageGenerationInThread";
    ModalOrigin["UNSPECIFIED_GENERALIZED_UPSELL"] = "unspecifiedGeneralizedUpsell";
    ModalOrigin["MILESTONE_ACHIEVED"] = "milestoneAchieved";
    ModalOrigin["STUDENT_LANDING_PAGE"] = "studentLandingPage";
    ModalOrigin["STOCK_PITCH_LANDING_PAGE"] = "stockPitchLandingPage";
    ModalOrigin["TASKS_PAGE"] = "tasksPage";
    ModalOrigin["MAX_URL_PAYWALL"] = "maxUrlPaywall";
    ModalOrigin["MODEL_SELECTOR"] = "modelSelector";
    ModalOrigin["ADVANCED_MODELS_QUOTA_LOW"] = "advancedModelsQuotaLow";
    ModalOrigin["DISCOVER_FEED_LIKE_BUTTON"] = "discoverFeedLikeButton";
    ModalOrigin["DISCOVER_FEED_DISLIKE_BUTTON"] = "discoverFeedDislikeButton";
    ModalOrigin["DISCOVER_FEED_TASK_WIDGET"] = "discoverFeedTaskWidget";
    ModalOrigin["SIDEBAR_BOTTOM_POPOVER"] = "sidebarBottomPopover";
    ModalOrigin["HOME_SIDEBAR"] = "homeSidebar";
    ModalOrigin["UPGRADE_MODAL"] = "upgradeModal";
    ModalOrigin["MAX_PAGE"] = "maxPage";
    ModalOrigin["COMET_INVITE"] = "cometInvite";
    ModalOrigin["LOGIN_FOR_COMET_AGENT_QUERIES_IN_THREAD"] = "loginForCometAgentQueriesInThread";
    ModalOrigin["COMET_AGENT_QUERIES_RATE_LIMITED_IN_THREAD"] = "cometAgentQueriesRateLimitedInThread";
    ModalOrigin["COMET_SIDECAR_RECURRING_NUDGE"] = "cometSidecarRecurringNudge";
    ModalOrigin["COMET_SIDECAR_UPGRADE"] = "cometSidecarUpgrade";
    ModalOrigin["PRO_UPGRADE_IN_SIDE_HOMEPAGE"] = "proUpgradeInSideHomepage";
    ModalOrigin["HOME_PRO_UPGRADE_TOP_BADGE"] = "homeProUpgradeTopBadge";
    ModalOrigin["VIDEO_GENERATION_IN_THREAD"] = "videoGenerationInThread";
    ModalOrigin["RESEARCH_UPSELL_IN_THREAD"] = "researchUpsellInThread";
    ModalOrigin["STUDENT_VERIFICATION_UPSELL"] = "studentVerificationUpsell";
    ModalOrigin["STUDENT_VERIFICATION_PAGE"] = "studentVerificationPage";
    ModalOrigin["STUDENT_VERIFICATION_PAYWALL"] = "studentVerificationPaywall";
    ModalOrigin["TRY_ASSISTANT_BUTTON"] = "tryAssistantButton";
    ModalOrigin["COMET_NTP"] = "cometNTP";
    ModalOrigin["ENTERPRISE_BILLING_BANNER"] = "enterpriseBillingBanner";
    ModalOrigin["ORG_CREDITS_PAGE_PAYWALL"] = "orgCreditsPagePaywall";
    ModalOrigin["ENTERPRISE_MAX_UPSELL"] = "enterpriseMaxUpsell";
    ModalOrigin["CANVAS_GENERATION_IN_THREAD"] = "canvasGenerationInThread";
    ModalOrigin["BROWSER_AGENT_CONFIRMATION_IN_THREAD"] = "browserAgentConfirmationInThread";
    ModalOrigin["CLASSROOM_UPLOAD"] = "classroomUpload";
    ModalOrigin["CLASSROOM_SPACED_REPETITION"] = "classroomSpacedRepetition";
    ModalOrigin["ENTERPRISE_UPSELL_URL_HANDLER"] = "enterpriseUpsellUrlHandler";
    ModalOrigin["ORG_DELETED_UPSELL"] = "orgDeletedUpsell";
    ModalOrigin["PREMIUM_SOURCE_TOOLTIP"] = "premiumSourceTooltip";
    // Cross-ref: pplx/common/core/billing/promos/stripe_consts.py COMET_WEB_ONBOARDING_PRO_TRIAL_ORIGIN
    ModalOrigin["COMET_WEB_ONBOARDING_PRO_TRIAL"] = "cometWebOnboardingProTrial";
    ModalOrigin["COMET_WEB_ONBOARDING_PRO_INTRO"] = "cometWebOnboardingProIntro";
    ModalOrigin["COMET_WEB_ONBOARDING_PLANS"] = "cometWebOnboardingPlans";
    ModalOrigin["THREAD_UPSELL_PAYMENT_MODAL"] = "threadUpsellPaymentModal";
    ModalOrigin["TRY_MODEL_COUNCIL"] = "tryModelCouncil";
    ModalOrigin["HEALTH_DASHBOARD"] = "healthDashboard";
    ModalOrigin["HEALTH_ONBOARDING_WIDGET"] = "healthOnboardingWidget";
    ModalOrigin["FINANCE_SINGULAR_AD_GATE"] = "financeSingularAdGate";
    ModalOrigin["FINANCE_PORTFOLIO"] = "financePortfolio";
    ModalOrigin["FINAL_PASS_WORKFLOW"] = "finalPassWorkflow";
    ModalOrigin["COMPUTER_UPSELL_BANNER"] = "computerUpsellBanner";
    ModalOrigin["COMPUTER_MAX_SIDE_CARD"] = "computerMaxSideCard";
    ModalOrigin["COMPUTER_PRO_SIDE_CARD"] = "computerProSideCard";
    // Cross-ref: pplx/common/core/billing/promos/stripe_consts.py COMPUTER_TRIAL_OFFER_ORIGIN
    ModalOrigin["COMPUTER_TRIAL_OFFER"] = "computerTrialOffer";
    ModalOrigin["PRO_ANNUAL_SWITCH_SIDEBAR"] = "proAnnualSwitchSidebar";
    ModalOrigin["COMPUTER_MAX_SIDE_CARD_ENTERPRISE_ADMIN"] = "computerMaxSideCardEnterpriseAdmin";
    ModalOrigin["COMPUTER_MAX_SIDE_CARD_ENTERPRISE_MEMBER"] = "computerMaxSideCardEnterpriseMember";
    ModalOrigin["COMPUTER_NEW_TASK"] = "computerNewTask";
    ModalOrigin["COMPUTER_SUBMIT_QUERY"] = "computerSubmitQuery";
    ModalOrigin["COMPUTER_WORKFLOW"] = "computerWorkflow";
    ModalOrigin["COMPUTER_AUTOMATIONS"] = "computerAutomations";
    ModalOrigin["COMPUTER_ASK_INPUT"] = "computerAskInput";
    ModalOrigin["COMPUTER_LANDING"] = "computerLanding";
    ModalOrigin["COMPUTER_LANDING_PAGE_MOBILE_CTA"] = "computerLandingPageMobileCta";
    ModalOrigin["COMPUTER_PAGE"] = "computerPage";
    ModalOrigin["COMPUTER_CREDITS_UPSELL"] = "computerCreditsUpsell";
    ModalOrigin["COMPUTER_SLACK_PAGE"] = "computerSlackPage";
    ModalOrigin["COMPUTER_MEMORY_PAGE"] = "computerMemoryPage";
    ModalOrigin["HOME_COMPUTER_BADGE"] = "homeComputerBadge";
    ModalOrigin["CREDITS_PAGE_SUBTITLE_UPGRADE"] = "creditsPageSubtitleUpgrade";
    ModalOrigin["CREDITS_BREAKDOWN_PLAN_TOOLTIP"] = "creditsBreakdownPlanTooltip";
    ModalOrigin["CREDITS_BREAKDOWN_PURCHASED_TOOLTIP"] = "creditsBreakdownPurchasedTooltip";
    ModalOrigin["CREDITS_PAGE_BONUS_EXPIRY_BANNER"] = "creditsPageBonusExpiryBanner";
    ModalOrigin["CREDITS_PAGE_UPGRADE_BANNER"] = "creditsPageUpgradeBanner";
    ModalOrigin["CREDITS_BADGE_POPOVER_UPGRADE"] = "creditsBadgePopoverUpgrade";
    ModalOrigin["FREE_TURN_PREVIEW_EYEBROW_UPGRADE"] = "freeTurnPreviewEyebrowUpgrade";
    ModalOrigin["COMPUTER_ASSET_START_TASK"] = "computerAssetStartTask";
    ModalOrigin["MEMORIES_PAGE"] = "memoriesPage";
    ModalOrigin["ADVANCED_SEARCH_CONTEXTUAL_UPSELL"] = "advancedSearchContextualUpsell";
    ModalOrigin["HOME_MICROSOFT_PRODUCTS_CARD"] = "homeMicrosoftProductsCard";
    ModalOrigin["HOME_PERSONAL_CFO_CARD"] = "homePersonalCfoCard";
    // Thread action upsells
    ModalOrigin["COMET_SET_DEFAULT_BROWSER_IN_THREAD"] = "cometSetDefaultBrowserInThread";
    ModalOrigin["CREATE_SHORTCUT_IN_THREAD"] = "createShortcutInThread";
    ModalOrigin["WAIT_FOR_CANVAS_GENERATION_IN_THREAD"] = "waitForCanvasGenerationInThread";
    ModalOrigin["VIRTUAL_TRY_ON_IN_THREAD"] = "virtualTryOnInThread";
    ModalOrigin["CONTEXT_LENGTH_LIMIT_IN_THREAD"] = "contextLengthLimitInThread";
    ModalOrigin["CONNECTOR_AUTH_IN_THREAD"] = "connectorAuthInThread";
    ModalOrigin["SHARE_LOCATION_IN_THREAD"] = "shareLocationInThread";
    ModalOrigin["DIFFICULT_QUERY_COMPUTER_IN_THREAD"] = "difficultQueryComputerInThread";
    ModalOrigin["DIFFICULT_QUERY_COMPUTER_FREE_USER_IN_THREAD"] = "difficultQueryComputerFreeUserInThread";
    ModalOrigin["DIFFICULT_QUERY_PRO_UPGRADE_IN_THREAD"] = "difficultQueryProUpgradeInThread";
    ModalOrigin["COMPLEX_QUERY_COMPUTER_REWRITE_IN_THREAD"] = "complexQueryComputerRewriteInThread";
    ModalOrigin["HEALTH_DASHBOARD_UPSELL_IN_THREAD"] = "healthDashboardUpsellInThread";
    // Computer contextual upsells
    ModalOrigin["COMPUTER_CODE_CONTEXTUAL_MAX_ACTIVATION"] = "computerCodeContextualMaxActivation";
    // Canvas contextual upsells
    ModalOrigin["CANVAS_CONTEXTUAL_ACTIVATION"] = "canvasContextualActivation";
    ModalOrigin["CANVAS_CONTEXTUAL_ACTIVATION_SLIDES"] = "canvasContextualActivationSlides";
    ModalOrigin["CANVAS_CONTEXTUAL_ACTIVATION_DOCUMENT"] = "canvasContextualActivationDocument";
    ModalOrigin["CANVAS_CONTEXTUAL_ACTIVATION_GENERIC"] = "canvasContextualActivationGeneric";
    ModalOrigin["CANVAS_MODEL_DEGRADATION"] = "canvasModelDegradation";
    // Premium sources computer upsells
    ModalOrigin["PREMIUM_SOURCES_COMPUTER"] = "premiumSourcesComputer";
    // Signal-based computer upsells
    ModalOrigin["DEEP_RESEARCH_COMPUTER"] = "deepResearchComputer";
    ModalOrigin["AGENTIC_INTENT_COMPUTER"] = "agenticIntentComputer";
    ModalOrigin["FINANCE_COMPUTER"] = "financeComputer";
    ModalOrigin["PERSONAL_FINANCE_COMPUTER"] = "personalFinanceComputer";
    ModalOrigin["PRODUCTIVITY_CONNECTORS_COMPUTER"] = "productivityConnectorsComputer";
    // Comet download intent upsells
    ModalOrigin["SHOPPING_INTENT_DOWNLOAD_COMET"] = "shoppingIntentDownloadComet";
    ModalOrigin["RESTAURANT_ATTRACTIONS_INTENT_DOWNLOAD_COMET"] = "restaurantAttractionsIntentDownloadComet";
    // Banner upsells
    ModalOrigin["COMET_DOWNLOAD_BANNER"] = "cometDownloadBanner";
    ModalOrigin["COMET_ANDROID_BANNER"] = "cometAndroidBanner";
    ModalOrigin["COMET_IOS_DOWNLOAD"] = "cometIosDownload";
    // Sidebar/side card upsells
    ModalOrigin["PRO_REFERRAL_SIDE_CARD"] = "proReferralSideCard";
    ModalOrigin["STUDENT_VERIFICATION_SIDE_CARD"] = "studentVerificationSideCard";
    ModalOrigin["WINBACK_CHURNED_PRO"] = "winbackChurnedPro";
    ModalOrigin["SLACK_MCP_CONNECTORS"] = "slackMcpConnectors";
    ModalOrigin["ENTERPRISE_CONSULTING_SIDE"] = "enterpriseConsultingSide";
    ModalOrigin["ENTERPRISE_PQL_COMPLIANCE"] = "enterprisePqlCompliance";
    ModalOrigin["TALK_TO_SALES_HOMEPAGE_EXPANSION"] = "talkToSalesHomepageExpansion";
    ModalOrigin["TALK_TO_SALES_HOMEPAGE_NET_NEW"] = "talkToSalesHomepageNetNew";
    ModalOrigin["ENTERPRISE_COMET_ADMIN"] = "enterpriseCometAdmin";
    ModalOrigin["ENTERPRISE_CONNECTOR_CONTROLS_ADMIN"] = "enterpriseConnectorControlsAdmin";
    ModalOrigin["ENTERPRISE_COMET_DOWNLOAD"] = "enterpriseCometDownload";
    ModalOrigin["PREMIUM_DATA_FOR_MAX"] = "premiumDataForMax";
    ModalOrigin["TASKS_IN_SPACES"] = "tasksInSpaces";
    ModalOrigin["ENTERPRISE_PRO_COMPUTER_SIDE"] = "enterpriseProComputerSide";
    ModalOrigin["GDRIVE_DIRECT_API"] = "gdriveDirectApi";
    ModalOrigin["USC_STUDY_HUB"] = "uscStudyHub";
    ModalOrigin["ENTERPRISE_MEMORY_ADMIN"] = "enterpriseMemoryAdmin";
    ModalOrigin["ENTERPRISE_MEMORY_ENABLE"] = "enterpriseMemoryEnable";
    ModalOrigin["ENTERPRISE_MEMORY_TRY"] = "enterpriseMemoryTry";
    ModalOrigin["ENTERPRISE_ONBOARDING_CONNECTORS"] = "enterpriseOnboardingConnectors";
    ModalOrigin["SNOWFLAKE_SERVICE_ACCOUNT_CONNECTOR"] = "snowflakeServiceAccountConnector";
    // Computer thread upsells
    ModalOrigin["COMPUTER_THREAD_UNSUPPORTED_APP_VERSION"] = "computerThreadUnsupportedAppVersion";
    // Comet NTP upsells
    ModalOrigin["COMET_NTP_STUDENT_VERIFICATION"] = "cometNtpStudentVerification";
    ModalOrigin["COMET_NTP_MOBILE_DOWNLOAD"] = "cometNtpMobileDownload";
    // Rate limit / feature limit upsells
    ModalOrigin["PRO_USER_PRO_SEARCH_LIMIT"] = "proUserProSearchLimit";
    ModalOrigin["PRO_USER_FILE_UPLOAD_LIMIT"] = "proUserFileUploadLimit";
    ModalOrigin["PRO_USER_RESEARCH_LIMIT"] = "proUserResearchLimit";
    ModalOrigin["INPUT_BANNER_ADVANCED_PREVIEW"] = "inputBannerAdvancedPreview";
    // Related query upsells
    ModalOrigin["AGENTIC_RESEARCH_RELATED_QUERY"] = "agenticResearchRelatedQuery";
    ModalOrigin["COMPUTER_RELATED_QUERY"] = "computerRelatedQuery";
    ModalOrigin["TASTE_OF_PRO"] = "tasteOfPro";
    // Persona computer upsells
    ModalOrigin["PERSONA_COMPUTER_IN_THREAD"] = "personaComputerInThread";
    // Personalized homepage upsells
    ModalOrigin["HOMEPAGE_BOTTOM_CARD_PERSONALIZED"] = "homepageBottomCardPersonalized";
    ModalOrigin["HOMEPAGE_BOTTOM_CARD_COMPUTER_ONBOARDING"] = "homepageBottomCardComputerOnboarding";
    ModalOrigin["HOMEPAGE_BOTTOM_CARD_COMPUTER_VIP_ADVISOR"] = "homepageBottomCardComputerVipAdvisor";
    ModalOrigin["COMPUTER_DESKTOP_LANDING_PAGE"] = "computerDesktopLandingPage";
    ModalOrigin["COMPUTER_IN_EXCEL_LANDING_PAGE"] = "computerInExcelLandingPage";
    ModalOrigin["COMPUTER_FOR_WINDOWS_LANDING_PAGE"] = "computerForWindowsLandingPage";
    ModalOrigin["ARTIFACTS_PAGE"] = "artifactsPage";
    ModalOrigin["MEMORY_PAGE"] = "memoryPage";
    // Settings upsells
    ModalOrigin["SETTINGS_BANNER_COMPUTER_VIP_ADVISOR"] = "settingsBannerComputerVipAdvisor";
    // Logged-out home education cards (GROW-4123)
    ModalOrigin["LOGGED_OUT_HOME_SEARCH_CARD"] = "loggedOutHomeSearchCard";
    ModalOrigin["LOGGED_OUT_HOME_COMPUTER_MODAL"] = "loggedOutHomeComputerModal";
    ModalOrigin["LOGGED_OUT_COMPUTER_DASHBOARD_PREVIEW"] = "loggedOutComputerDashboardPreview";
})(ModalOrigin || (ModalOrigin = {}));
export const MODAL_ORIGINS = new Set(Object.values(ModalOrigin));
export function parseModalOrigin(origin) {
    if (origin && MODAL_ORIGINS.has(origin)) {
        return origin;
    }
    return undefined;
}
export const MODEL_PROVIDERS = [
    // keep in sync with ModelProvider in the BE
    'ANTHROPIC',
    'AWS',
    'AZURE',
    'OPENAI',
    'DEEPSEEK',
    'XAI',
    'GOOGLE',
    'SONAR',
    'FIREWORKS',
    'MOONSHOT_AI',
    'NVIDIA',
    'ZAI',
];
// Maps to the backend enum in database.py
export var AccessLevel;
(function (AccessLevel) {
    AccessLevel[AccessLevel["OWNER_ONLY"] = 0] = "OWNER_ONLY";
    AccessLevel[AccessLevel["PRIVATE_READ"] = 1] = "PRIVATE_READ";
    AccessLevel[AccessLevel["PUBLIC_READ"] = 2] = "PUBLIC_READ";
    AccessLevel[AccessLevel["PUBLIC_PUBLISHED"] = 3] = "PUBLIC_PUBLISHED";
    AccessLevel[AccessLevel["ORG_READ"] = 4] = "ORG_READ";
    AccessLevel[AccessLevel["COLLECTION_READ"] = 5] = "COLLECTION_READ";
    AccessLevel[AccessLevel["SPECIFIC_PEOPLE_READ"] = 6] = "SPECIFIC_PEOPLE_READ";
    AccessLevel[AccessLevel["ORG_WRITE"] = 7] = "ORG_WRITE";
})(AccessLevel || (AccessLevel = {}));
export var NavigationSource;
(function (NavigationSource) {
    NavigationSource["SEARCH_V2_NAVIGATE"] = "search_v2_navigate";
    NavigationSource["SEARCH_V3_NAVIGATE"] = "search_v3_navigate";
    NavigationSource["WEB_RESULTS"] = "web_results";
    NavigationSource["COMET"] = "comet";
})(NavigationSource || (NavigationSource = {}));
//# sourceMappingURL=types.js.map